<template>
  <div v-if="hasImportedOrderAddendum || hasDealerOrderAddendum" class="addendum-bar">
    <div class="addendum-bar__text">
      <div v-if="hasImportedOrderAddendum" v-html="importerOrder"></div>
      <div v-if="hasDealerOrderAddendum" v-html="dealerOrder"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      dealerOrder: 'quote/dealerOrder',
      importerOrder: 'quote/importerOrder',
    }),
    hasDealerOrderAddendum() {
      return !this.isStringEmpty(this.dealerOrder)
    },
    hasImportedOrderAddendum() {
      return !this.isStringEmpty(this.importerOrder)
    },
  },
  methods: {
    isStringEmpty(stringValue) {
      if (!stringValue) return true

      let emptyValuesRegex = /(\s|null)+/g
      let stringTrim = stringValue.replace(emptyValuesRegex, '')

      return !stringTrim
    },
  },
}
</script>

<style lang="scss" scoped>
.addendum-bar {
  padding: 0.5rem 0;
  background-color: orange;

  &__text {
    font-weight: $font-weight-bold;
    color: $gray-darker;
    margin: 0 2rem;
  }
}
</style>
